/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Activeeventsusage2Inputs */

const en_activeeventsusage2 = /** @type {(inputs: Activeeventsusage2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Active events: ${i?.used}/${i?.max}`)
};

const de_activeeventsusage2 = /** @type {(inputs: Activeeventsusage2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktive Events: ${i?.used}/${i?.max}`)
};

/**
* | output |
* | --- |
* | "Active events: {used}/{max}" |
*
* @param {Activeeventsusage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const activeeventsusage2 = /** @type {((inputs: Activeeventsusage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activeeventsusage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_activeeventsusage2(inputs)
	return de_activeeventsusage2(inputs)
});
export { activeeventsusage2 as "activeEventsUsage" }